import { baseService } from "../base";

export interface InviteCode {
  id: string;
  code: string;
  label: string | null;
  status: "active" | "exhausted" | "revoked" | "expired";
  maxUses: number;
  timesUsed: number;
  expiresAt: string | null;
  createdAt: string;
  createdBy?: {
    id: string;
    firstName: string;
    lastName: string;
    username: string;
  };
}

export interface CreateInviteCodePayload {
  label?: string;
  maxUses?: number;
  expiresAt?: string;
}

export const inviteCodesService = {
  create: async (payload: CreateInviteCodePayload): Promise<InviteCode> => {
    const { data } = await baseService.post("/invite-codes", payload);
    return data;
  },

  findAll: async (): Promise<InviteCode[]> => {
    const { data } = await baseService.get("/invite-codes");
    return data;
  },

  validate: async (code: string): Promise<{ valid: boolean; label: string | null; remainingUses: number }> => {
    const { data } = await baseService.post("/invite-codes/validate", { code });
    return data;
  },

  revoke: async (id: string): Promise<InviteCode> => {
    const { data } = await baseService.delete(`/invite-codes/${id}`);
    return data;
  },
};
